import React from "react";
import ModalShell from "../modal/ModalShell";

interface FormModalProps {
  onClose: () => void;
  children: React.ReactNode;
}

/**
 * Centered overlay dialog for the billing create/edit forms, so opening a form
 * from a bottom row doesn't require scrolling back to the top of the grid.
 * Built on the shared ModalShell: Escape / backdrop close, focus trap,
 * scrollable panel on small screens.
 */
const FormModal: React.FC<FormModalProps> = ({ onClose, children }) => (
  <ModalShell onClose={onClose} maxWidthClassName="max-w-2xl">
    {children}
  </ModalShell>
);

export default FormModal;
